import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const DynamicSidebar = ({ menus = [] }) => {
    const [openMenuId, setOpenMenuId] = useState(null);
    const location = useLocation();

    const toggleMenu = (id) => {
        setOpenMenuId((prev) => (prev === id ? null : id));
    };

    const isActive = (path) => {
        if (!path) return false;
        return location.pathname === path;
    };

    const renderMenu = (menu, level = 0) => {
        const hasChildren = menu.children && menu.children.length > 0;
        const isOpen = openMenuId === menu.intMenuId;

        return (
            <li key={menu.intMenuId}>

                {/* Parent */}
                {hasChildren ? (
                    <>
                        <div
                            onClick={() => toggleMenu(menu.intMenuId)}
                            style={{
                                cursor: "pointer",
                                padding: "10px 14px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderRadius: "6px",
                                margin: "4px 8px",
                                background: isOpen ? "#f4f6fb" : "transparent",
                                transition: "all 0.2s ease"
                            }}
                        >
                            {/* ICON + TEXT */}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: level === 0 ? "12px" : "8px",
                                    paddingLeft: level > 0 ? "10px" : "0px",
                                    fontSize: level === 0 ? "16px" : "13px",
                                }}
                            >
                                {level === 0 && (
                                    <span
                                        style={{ display: "flex", width: "18px", height: "18px", color: isActive(menu.vchPath) ? "#fff" : "#6c63ff" }}
                                        dangerouslySetInnerHTML={{
                                            __html: menu.vchIconSvg || "",
                                        }}
                                    />
                                )}
                                <span>{menu.vchMenuName}</span>
                            </div>

                            <span style={{ fontSize: "12px", opacity: 0.6 }}>
                                {isOpen ? "▼" : "▶"}
                            </span>
                        </div>

                        {isOpen && (
                            <ul style={{
                                listStyle: "none",
                                paddingLeft: "5px",
                                marginLeft: "30px",
                                borderLeft: "2px dashed #ccc",
                            }}>
                                {menu.children.map((child) =>
                                    renderMenu(child, level + 1)
                                )}
                            </ul>
                        )}
                    </>
                ) : (

                    /* Leaf */
                    <NavLink
                        to={menu.vchPath || ""}
                        onClick={() => {
                            if (window.innerWidth < 1200) {
                                setTimeout(() => {
                                    document.getElementById("mobileSidebarClose")?.click();
                                }, 0);
                            }
                        }}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            padding: "8px 14px",
                            textDecoration: "none",
                            borderRadius: "6px",
                            margin: "2px 8px",
                            fontSize: "15px",
                            background: isActive(menu.vchPath)
                                ? "linear-gradient(45deg, #6c63ff, #8f6ed5)"
                                : "transparent",
                            color: isActive(menu.vchPath) ? "#fff" : "#555",
                            transition: "all 0.2s ease"
                        }}
                    >

                        {/* ICON */}
                        {level === 0 && (
                            <span
                                style={{ display: "flex", width: "18px", height: "18px", color: isActive(menu.vchPath) ? "#fff" : "#6c63ff" }}
                                dangerouslySetInnerHTML={{
                                    __html: menu.vchIconSvg || "",
                                }}
                            />
                        )}

                        {menu.vchMenuName}
                    </NavLink>
                )}
            </li>
        );
    };

    if (!menus || menus.length === 0) {
        return <div style={{ padding: 10 }}>No menu found</div>;
    }

    return (
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {menus.map((menu) => renderMenu(menu))}
        </ul>
    );
};

export default DynamicSidebar;